<template>
  <v-dialog width="600" v-model="dialog" scrollable>
    <gg-card>
      <gg-toolbar @close="close">
        Edit an {{ typeSelect }} record for {{ item.domain }}
      </gg-toolbar>

      <gg-card-text>
        <gg-input-label>Record Type</gg-input-label>
        <v-select
          v-model="typeSelect"
          class="gg-input"
          outlined
          dense
          :items="types"
        />
        <a-record-form v-if="typeSelect === 'A'" @send-data="retrieveData" :item="item" edit />
        <a-a-a-record-form v-else-if="typeSelect === 'AAAA'" @send-data="retrieveData" :item="item" edit />
        <c-name-record-form v-else-if="typeSelect === 'CNAME'" @send-data="retrieveData" :item="item" edit />
        <c-a-a-record-form v-else-if="typeSelect === 'CAA'" @send-data="retrieveData" :item="item" edit />
        <s-r-v-record-form v-else-if="typeSelect === 'SRV'" @send-data="retrieveData" :item="item" edit />
        <t-x-t-record-form v-else-if="typeSelect === 'TXT'" @send-data="retrieveData" :item="item" edit />
        <m-x-record-form v-else-if="typeSelect === 'MX'"
                         :domain="item.domain"
                         @send-data="retrieveData"
                         :item="item"
                         edit></m-x-record-form>
        <d-m-a-r-k-record-form v-else-if="typeSelect === 'DMARC'"
                               :domain="item.domain"
                               @send-data="retrieveData"
                               :item="item"
                               edit></d-m-a-r-k-record-form>
      </gg-card-text>
      <v-card-actions class="justify-end">
        <gg-btn secondary @click="close">
          Cancel
        </gg-btn>
        <gg-btn :loading="loading" @click="editRecord">
          Update
        </gg-btn>
      </v-card-actions>
    </gg-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import modalMixin from '@/mixins/modal'
import ARecordForm from './Records/ARecordForm'
import AAARecordForm from './Records/AAARecordForm'
import CNameRecordForm from './Records/CNameRecordForm'
import MXRecordForm from './Records/MXRecordForm'
import CAARecordForm from './Records/CAARecordForm'
import DMARKRecordForm from './Records/DMARKRecordForm'
import SRVRecordForm from './Records/SRVRecordForm'
import TXTRecordForm from './Records/TXTRecordForm'

export default {
  name: 'EditRecordModal',
  mixins: [modalMixin],
  components: {
    ARecordForm,
    AAARecordForm,
    CNameRecordForm,
    MXRecordForm,
    CAARecordForm,
    DMARKRecordForm,
    SRVRecordForm,
    TXTRecordForm,
  },
  props: {
    item: {
      type: Object
    },
    username: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      loading: false,
      typeSelect: '',
      types: ['A', 'AAAA', 'CAA', 'CNAME', 'MX', 'SRV', 'TXT']
    }
  },
  methods: {
    ...mapActions(['cpanel_api2', 'cpanel_uapi', 'reportError', 'reportSuccess']),
    // https://documentation.cpanel.net/display/DD/cPanel+API+2+Functions+-+ZoneEdit%3A%3Aedit_zone_record
    async editRecord () {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      this.loading = true
      let data = {
        _username: this.username || this.$route.query.user,
      }
      switch (this.typeSelect) {
        case 'MX': {
          data = {
            api2_module: 'ZoneEdit',
            api2_method: 'edit_zone_record',
            line: this.model.line,
            domain: this.model.domain,
            name: this.model.name,
            type: this.typeSelect,
            preference: this.model.priority,
            exchange: this.model.exchanger,
            _username: this.username || this.$route.query.user,
          }

          break
        }
        default: {
          data['api2_module'] = 'ZoneEdit'
          data['api2_method'] = 'edit_zone_record'
          data['domain'] = this.domain
          this.item.type === 'DMARC' ? data['type'] = 'TXT' : data['type'] = this.type

          for (let key in this.model) {
            if (this.model.hasOwnProperty(key)) {
              data[key] = this.model[key]
            }
          }
          data['type'] = this.typeSelect
          break
        }
      }

      try {
        const res = await this.cpanel_api2(data)

        res.payload.data.forEach(item => {
          if (!item.result.status) {
            this.loading = false
            this.reportError(item.result.statusmsg)
          } else {
            this.reportSuccess(
              `You successfully edited the following ${this.item.type} record for “${this.item.domain}”: ` +
               `${this.model.name}.`
            )
            this.loading = false
            this.close()
            this.$emit('action-completed')
          }
        })
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    },
    retrieveData (payload) {
      this.model = payload
    }
  },
  provide () {
    // Validation
    return { parentValidator: this.$validator }
  },
  mounted () {
    this.typeSelect = this.item.type
  }
}
</script>
